import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, error, hint, className = '', id, ...rest },
  ref,
) {
  const inputId = id ?? `input-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="flex flex-col gap-1">
      {label !== undefined && label !== '' && (
        <label htmlFor={inputId} className="text-xs font-medium text-slate-300">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={`bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:border-floryon-green focus:outline-none focus:ring-1 focus:ring-floryon-green/50 ${className}`}
        {...rest}
      />
      {hint !== undefined && hint !== '' && error === undefined && (
        <p className="text-xs text-slate-500">{hint}</p>
      )}
      {error !== undefined && error !== null && error !== '' && (
        <p className="text-xs text-red-400">{error}</p>
      )}
    </div>
  );
});
